import TagsPage from "./TagsPage";

export default function TagsRoute() {
  return <TagsPage />;
}
